import { render, staticRenderFns } from "./TrangXemNguoiDung.vue?vue&type=template&id=7a7964b7&"
import script from "./TrangXemNguoiDung.vue?vue&type=script&lang=js&"
export * from "./TrangXemNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports